import { Helmet } from 'react-helmet-async';

const MetaDecoration = ({
    title = "Sistema de gestión de concesionaria",
    description = "Con Linze 360 puedes administrar tu concesionaria, sucursales y vendedores", 
    image = "https://res.cloudinary.com/gtt-dev/image/upload/v1681738556/metaImage_r5ausy.png"
}: any) => {

    return(
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta property="og:description" content={description} />
            <meta name="twitter:description" content={description} />

            <meta property="og:image" content={image} />
            <meta itemProp="image" content={image} />
        </Helmet>
    )
}

export default MetaDecoration;